import { BASE_URL, DASHBOARD_WIDGETS, GET } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";
import { getTimePeriodByDuration } from "../../utils/dateTime";

export const fetchDashboarddata = async (action, filterOptions = "",uniqueCustomerRefId = "",startDate="",endDate="") => {
  const token = await getAccessToken();
  const { start: utcStartDate, end: utcEndDate } = getTimePeriodByDuration(startDate, endDate);
  let url = `${BASE_URL}${DASHBOARD_WIDGETS}${action}`;
  let array = [
    {
      key: "filterOptions",
      value: encodeURIComponent(filterOptions),
    },
    {
      key: "uniqueCustomerRefId",
      value: encodeURIComponent(uniqueCustomerRefId),
    },
    {
      key: "startDate",
      value: encodeURIComponent(utcStartDate),
    },
    {
      key: "endDate",
      value: encodeURIComponent(utcEndDate),
    },
  ];
  let queryString = ``;
  array.forEach((item) => {
    if (item.value && item.value !== "undefined" && item.value !== "") {
      if (queryString) {
        queryString = queryString + `&${item.key}=${item.value}`;
      } else {
        queryString = `${item.key}=${item.value}`;
      }
    }
  });
  if (queryString) {
    url = `${url}&${queryString}`;
    url = url.replace("filter=&", "");
  }
  return fetch(url, {
    method: GET,
    headers: {
      "Content-Type": "application/json",
      userauth: `Bearer ${token}`,
    },
  })
    .then(statusParsing)
    .then(jsonParsing);
};
